import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Paper, useInView} from 'views/components';
import {ErrorBoundary} from 'views/module';
import SkeletonComponent from './utils/skeleton/SkeletonComponent';

import ErrorComponent from './utils/ErrorComponent';

const Widget = (props) => {
  const WidgetComponent = props.component;
  const uuid = props.uuid;
  const settings = props.settings;
  const removeWidget = props.removeWidget;
  const saveWidgetSettings = props.saveWidgetSettings;
  const editMode = props.editMode;
  const dashboardSettings = props.dashboardSettings;


  const {ref, inView} = useInView({
    threshold: 0,
    triggerOnce: true,
    fallbackInView: true,
  });

  return (
    <Paper ref={ref} sx={{p: 1, height: '100%'}}>
      <ErrorBoundary
        FallbackComponent={ErrorComponent}
      >
        {
          inView || editMode ?
          <WidgetComponent
            removeWidget={() => removeWidget(uuid)}
            editMode={editMode}
            settings={settings}
            saveWidgetSettings={(e) => saveWidgetSettings(uuid, e)}
            inView={inView}
            dashboardSettings={dashboardSettings}
          />:
          <SkeletonComponent />
        }
      </ErrorBoundary>
    </Paper>
  );
};

Widget.propTypes = {
  component: PropTypes.object.isRequired,
  uuid: PropTypes.string.isRequired,
  settings: PropTypes.object,
  removeWidget: PropTypes.func.isRequired,
  saveWidgetSettings: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  dashboardSettings: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Widget));
